import React from 'react'
import placeholder from 'images/placeholders/placeholder-new.jpg'
import auto1 from 'images/content-creator/auto-1.png'
import auto2 from 'images/content-creator/auto-2.png'
import mobileauto1 from 'images/content-creator/mobile-auto-1.png'
import mobileauto2 from 'images/content-creator/mobile-auto-2.png'
import beauty1 from 'images/content-creator/beauty-1.png'
import beauty2 from 'images/content-creator/beauty-2.png'
import beauty3 from 'images/content-creator/beauty-3.png'
import mobilebeauty1 from 'images/content-creator/mobile-beauty-1.png'
import mobilebeauty2 from 'images/content-creator/mobile-beauty-2.png'
import mobilebeauty3 from 'images/content-creator/mobile-beauty-3.png'
import fashion1 from 'images/content-creator/fashion-1.png'
import fashion2 from 'images/content-creator/fashion-2.png'
import fashion3 from 'images/content-creator/fashion-3.png'
import mobilefashion1 from 'images/content-creator/mobile-fashion-1.png'
import mobilefashion2 from 'images/content-creator/mobile-fashion-2.png'
import mobilefashion3 from 'images/content-creator/mobile-fashion-3.png'
import fmcg1 from 'images/content-creator/fmcg-1.png'
import fmcg2 from 'images/content-creator/fmcg-2.png'
import fmcg3 from 'images/content-creator/fmcg-3.png'
import mobilefmcg1 from 'images/content-creator/mobile-fmcg-1.png'
import mobilefmcg2 from 'images/content-creator/mobile-fmcg-2.png'
import mobilefmcg3 from 'images/content-creator/mobile-fmcg-3.png'
import health1 from 'images/content-creator/health-1.png'
import health2 from 'images/content-creator/health-2.png'
import mobilehealth1 from 'images/content-creator/mobile-health-1.png'
import mobilehealth2 from 'images/content-creator/mobile-health-2.png'
import pets1 from 'images/content-creator/pets-1.png'
import pets2 from 'images/content-creator/pets-2.png'
import pets3 from 'images/content-creator/pets-3.png'
import mobilepets1 from 'images/content-creator/mobile-pets-1.png'
import mobilepets2 from 'images/content-creator/mobile-pets-2.png'
import mobilepets3 from 'images/content-creator/mobile-pets-3.png'
import tech1 from 'images/content-creator/tech-1.png'
import tech2 from 'images/content-creator/tech-2.png'
import tech3 from 'images/content-creator/tech-3.png'
import mobiletech1 from 'images/content-creator/mobile-tech-1.png'
import mobiletech2 from 'images/content-creator/mobile-tech-2.png'
import mobiletech3 from 'images/content-creator/mobile-tech-3.png'
import travel1 from 'images/content-creator/travel-1.png'
import travel2 from 'images/content-creator/travel-2.png'
import travel3 from 'images/content-creator/travel-3.png'
import mobiletravel1 from 'images/content-creator/mobile-travel-1.png'
import mobiletravel2 from 'images/content-creator/mobile-travel-2.png'
import mobiletravel3 from 'images/content-creator/mobile-travel-3.png'
import LimitedViewText from './LimitedViewText'

export default function ContentCreators({
  category,
  topTweeters,
  limitedView,
}) {
  const topProfiles = topTweeters.results
  return (
    <section className="section" data-anchor="content_creators">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex relative">
        <div className="col-12 flex flex-column relative z1">
          <div className="flex-auto">
            <h2 className="persona-sub-title center p4 pdf-p2 sm-p3">Content Creators Relevant To Your Category</h2>
          </div>

          <div className="p3 sm-p0">
            <div className="flex flex-wrap mxn2 sm-block">
              {category === 'Automotive ' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={auto1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobileauto1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={auto2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobileauto2} />
                  </div>
                </>
              )}

              {category === 'Beauty' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={beauty1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilebeauty1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={beauty2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilebeauty2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={beauty3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilebeauty3} />
                  </div>
                </>
              )}

              {category === 'Electronics & Gaming' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={tech1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletech1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={tech2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletech2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={tech3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletech3} />
                  </div>
                </>
              )}

              {category === 'Fashion' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fashion1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefashion1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fashion2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefashion2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fashion3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefashion3} />
                  </div>
                </>
              )}

              {category === 'FMCG' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fmcg1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefmcg1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fmcg2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefmcg2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={fmcg3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilefmcg3} />
                  </div>
                </>
              )}

              {category === 'Health And Fitness' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={health1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilehealth1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={health2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilehealth2} />
                  </div>
                </>
              )}

              {category === 'Pets & Pet Services' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={pets1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilepets1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={pets2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilepets2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={pets3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobilepets3} />
                  </div>
                </>
              )}

              {category === 'Travel & Tourism' && (
                <>
                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={travel1} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletravel1} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={travel2} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletravel2} />
                  </div>

                  <div className="col-6 flex mb3 px2 sm-block sm-col-12">
                    <img alt="" className="sm-hide" src={travel3} />
                    <img alt="" className="hidden sm-mx-auto sm-show" src={mobiletravel3} />
                  </div>
                </>
              )}

              {/*
              {topProfiles.map((profile, idx) => {
                if (idx < 3) {
                  profile = profile.data;
                  return (
                    <div key={idx} className="col-6 flex mb3 px2 sm-block sm-col-12">
                      <div
                        className="bg-center bg-cover bg-no-repeat circle mr2 sm-mb3 sm-mx-auto"
                        style={{ backgroundImage: `url(${profile.twitterAvatar})`, height: 80, minWidth: 80, width: 80 }}
                      />

                      {limitedView ?
                        <div>
                          <table className="persona-table box-shadow-strong">
                            <tbody>
                              <tr>
                                <td><LimitedViewText /></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        : <div>
                          <table className="persona-table box-shadow-strong h5">
                            <tbody>
                              <tr>
                                <th colSpan="2">{profile.authorInterest ? profile.authorInterest.join(' & ') : ''}</th>
                                <th colSpan="2">@{profile.authorName}</th>
                              </tr>

                              <tr>
                                <td colSpan="4">{profile.twitterPageTitle}</td>
                              </tr>

                              <tr>
                                <td>Influence: <b>{profile.monthlyVisitors}</b></td>
                                <td>Tweets: <b>{profile.twitterTweets}</b></td>
                                <td>Followers: <b>{profile.twitterFollowers}</b></td>
                                <td>Following: <b>{profile.twitterFollowing}</b></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      }
                    </div>
                  )
                }
              })}
              */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
